import React, { Component } from 'react'
import '../../../CSS/dashboard.css'
import ReusableButton from '../../../SharedComponents/Button/Button'
import 'jquery-ui-dist/jquery-ui.min.css';
import { NavLink } from 'react-router-dom'
import { DateRange } from 'react-date-range'
import { isIE } from 'react-device-detect';
import moment from "moment";
import Loading from '../../../Images/loading.gif'
import * as DashboardCleanersHeaderConstant from './DashboardCleanersHeaderConstant'
import { Redirect } from 'react-router-dom'
import DashboardCleanerLogo from '../../../SharedComponents/DashboardCleanerLogo/DashboardCleanerLogo'
import { IoIosContact } from 'react-icons/io'
import { destroySession } from '../../../Utility/Utility'
import { StoresDropDown } from '../../../CleanersDashboardAPI/CleanersDashboardStoresDropDownAPI'
import { Link } from 'react-router-dom'
import { IconContext } from "react-icons";
import CleanersDashboardHome from '../../CleanersDashboardHome/CleanersDashboardHome'
const $ = require('jquery')
const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

class DashboardCleanersHeader extends Component {
  constructor(props) {
    super();
    this.state = {
      userName: '',
      FirstName: '',
      LastName: '',
      redirectLogin: false,
      Name: '',
      showDate: false,
      showDateToggle: false,
      startDate: null,
      endDate: null,
      startDateSelect: null,
      endDateSelect: null,
      showTime: false,
      value: {
        start: "00:00",
        end: "23:59"
      },
      startTime: null,
      endTime: null,
      timeRender: false,
      currentDate: "",
      userName: "",
      allStoreDisplay: false,
      roleName: '',
      selectedDates: true,
      sessionStartDate: '',
      sessionEndDate: '',
      sessionStartUIDate: '',
      sessionEndUIDate: '',
      chrome: false,
      arrayStores: [],
      selectedStore: '',
      startDateSelected: moment().subtract(6, "days"),
      endDateSelected: moment(),
      redirectError400: false,
      redirectError401: false,
      redirectError404: false,
      redirectError500: false,
      role: '',
      VendorName: '',
      roleID: '',
      ieStartDateSelect: '',
      ieEndDateSelect: '',
      ieStartDate: "",
      ieEndDate: ''

    }
    this._toggleDiv = this._toggleDiv.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleApplyDate = this.handleApplyDate.bind(this);
    this.handleCancelDate = this.handleCancelDate.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleStores = this.handleStores.bind(this);
    this.ieISOFormat = this.ieISOFormat.bind(this);

  }
  _toggleDiv() {
    // $(document).ready(function() {
    $(this.refs['toggle-div']).slideToggle()
    // })
  }
  handleStores = (e) => {
    this.setState({
      selectedStore: e.target.value
    })
    sessionStorage.setItem('selectedStore', e.target.value)
  }

  // handleDates() {
  //   var PropStartDate = this.state.sessionStartUIDate
  //   var PropEndDate = this.state.sessionEndUIDate
  // }

  componentDidMount() {
    $(window).on('scroll', function () {
      var myDiv = $('.CoopHeaderDashboard');
      var st = $(this).scrollTop();
      myDiv.height(st);
      if (st >= 50) {
        $(".CoopHeaderDashboard").css("height", "40");
      }
      else {
        $(".CoopHeaderDashboard").css("height", "90");
      }
    })
  }
  componentWillMount() {
    if (sessionStorage.getItem('token')) {
      var Role = sessionStorage.getItem('role')
      this.setState({
        roleID: Role
      })
      var VendorName = sessionStorage.getItem('vendorName')
      if (Role == "1") {
        Role = VendorName + " " + "Admin"
        this.setState({
          roleName: Role,
          VendorName: VendorName
        })
      }
      if (Role == "3") {
        Role = "Super Admin"
        this.setState({
          roleName: Role,
        })
      }
      var Name = sessionStorage.getItem('name')
      this.setState({
        Name: Name
      })
      if (isIE) {
        let ieStartDateOnLoad = moment().subtract(6, "days").format('YYYY-MM-DD')
        let ieEndDateOnLoad = moment().format('YYYY-MM-DD')
        sessionStorage.setItem('startDate', ieStartDateOnLoad)
        sessionStorage.setItem('endDate', ieEndDateOnLoad)
        this.setState({
          sessionStartUIDate: moment(ieStartDateOnLoad).format('MMM DD, YYYY'),
          sessionEndUIDate: moment(ieEndDateOnLoad).format('MMM DD, YYYY')
  
        })
      }
      else {
        let startOnLoad = moment().subtract(6, "days")
        let endDateOnLoad = moment()
        sessionStorage.setItem('startDate', this.formatDate(startOnLoad))
        sessionStorage.setItem('endDate', this.formatDate(endDateOnLoad))
        this.setState({
          sessionStartUIDate: this.formatDate(startOnLoad),
          sessionEndUIDate: this.formatDate(endDateOnLoad)
  
        })
      }
      this.loadStores();
      sessionStorage.setItem('selectedStore', 0)
    }
    else {
      this.setState({
        redirectLogin: true
      })
    }
  }
  loadStores() {
    let TokenDataApi = sessionStorage.getItem('token');
    const AuthStr = 'bearer '.concat(TokenDataApi);
    let UserId = sessionStorage.getItem('userId')
    let arrayStores = []
    this.setState({
      loading: true
    })
    StoresDropDown(UserId, AuthStr).then(res => {
      let responseJSON = res;
      if (responseJSON.status == 200) {
        let arrayresponse = responseJSON.data.dataSet
        Object.keys(arrayresponse).forEach(function (key) {
          arrayStores.push({
            StoreId: arrayresponse[key].storeId, StoreName: arrayresponse[key].name,
          })
        });
        this.setState({
          arrayStores: arrayStores,
          loading: false
        })
      }
      else if (responseJSON.status == 400) {
        this.setState({
          redirectError400: true,
          loading: false
        })
      }
      else if (responseJSON.status == 401) {
        this.setState({
          redirectError401: true,
          loading: false
        })
      }
      else if (responseJSON.status == 404) {
        this.setState({
          redirectError404: true,
          loading: false
        })
      }
      else if (responseJSON.status == 500) {
        this.setState({
          redirectError500: true,
          loading: false
        })
      }
    })
  }
  handleSelect(range) {
    if (isIE) {
      let ieStartDate = this.ieISOFormat(range.startDate._d)
      let ieEndDate = this.ieISOFormat(range.endDate._d)
      this.setState({
        ieStartDateSelect: ieStartDate,
        ieEndDateSelect: ieEndDate
      })
    }
    else {
      let startDate = this.formatDate(range.startDate._d);
      let endDate = this.formatDate(range.endDate._d);
      this.setState({
        startDateSelect: startDate,
        endDateSelect: endDate
      })
    }
  }
  ieISOFormat(date) {
    var d = new Date(date);
    d.setTime(d.getTime() + 30 * 60 * 1000);
    return d.toISOString();
  }
  handleApplyDate() {
    let startOnLoad = moment().subtract(6, "days")
    let endDateOnLoad = moment()
    if (isIE) {
      var ieStartDateUI = moment(this.state.ieStartDateSelect).format('MMM DD, YYYY').split("T")[0]
      var ieEndDateUI = moment(this.state.ieEndDateSelect).subtract(1, "day").format('MMM DD, YYYY').split("T")[0]
      let ieStartDate = moment(ieStartDateUI).format('YYYY-MM-DD')
      let ieEndDate = moment(ieEndDateUI).format('YYYY-MM-DD')
      sessionStorage.setItem('startDate', ieStartDate)
      sessionStorage.setItem('endDate', ieEndDate)
      this.setState({
        ieStartDate: ieStartDate,
        ieEndDate: ieEndDate
      })
      if (ieStartDateUI == null || ieEndDateUI == null) {
        let ieStartDateNull = moment().subtract(6, "days").format('YYYY-MM-DD')
        let ieEndDateNull = moment().format('YYYY-MM-DD')
        sessionStorage.setItem('startDate', ieStartDateNull)
        sessionStorage.setItem('endDate', ieEndDateNull)
        this.setState({
          sessionStartUIDate: sessionStorage.getItem('startDate'),
          sessionEndUIDate: sessionStorage.getItem('endDate')
        })
      }
      else {
        this.setState({
          sessionStartUIDate: ieStartDateUI,
          sessionEndUIDate: ieEndDateUI
        })
      }
    }
    else {
      this.setState({
        startDate: this.state.startDateSelect,
        endDate: this.state.endDateSelect
      })
      let date = new Date(this.state.startDateSelect)
      sessionStorage.setItem('startDate', date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + (date.getDate()))
      let endDateUpdated = new Date(this.state.endDateSelect)
      sessionStorage.setItem('endDate', endDateUpdated.getFullYear() + '-' + (endDateUpdated.getMonth() + 1) + '-' + (endDateUpdated.getDate()))
      let startDate = sessionStorage.getItem('startDate')
      let endDate = sessionStorage.getItem('endDate')
      if (startDate == null || endDate == null) {
        sessionStorage.setItem('startDate', this.formatDate(startOnLoad))
        sessionStorage.setItem('endDate', this.formatDate(startOnLoad))
        this.setState({
          sessionStartUIDate: sessionStorage.getItem('startDate'),
          sessionEndUIDate: sessionStorage.getItem('endDate')
        })
      }
      else {
        this.setState({
          // selectedDates: true,
          sessionStartUIDate: this.formatDate(sessionStorage.getItem('startDate')),
          sessionEndUIDate: this.formatDate(sessionStorage.getItem('endDate')),
          // sessionStartDate: sessionStorage.getItem('startDate'),
          // sessionEndDate: sessionStorage.getItem('endDate'),
        })
      }
    }

    this._toggleDiv();
  }
  formatDate(string) {
    var options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(string).toLocaleDateString([], options);
  }

  handleCancelDate() {
    this._toggleDiv();
  }
  handleLogout() {
    destroySession();
    this.setState({
      redirectLogin: true
    })
  }
  render() {
    if (this.state.redirectLogin) {
      return (<Redirect to={'/DashboardLogin'} />)
    }
    if (this.state.redirectError400) {
      return (<Redirect to={'/CleanersDashboardError400'} />)
    }
    if (this.state.redirectError401) {
      return (<Redirect to={'/CleanersDashboardError401'} />)
    }
    if (this.state.redirectError404) {
      return (<Redirect to={'/CleanersDashboardError404'} />)
    }
    if (this.state.redirectError500) {
      return (<Redirect to={'/CleanersDashboardError500'} />)
    }
    return (
      <div>
        {this.state.loading ?
          <div className="overlay"><img src={Loading} alt="Loading" className="loadingSignOut" /></div> : null}
        <div className="CoopHeaderDashboard" >
          <div className="CoopHeader">
            <DashboardCleanerLogo />
            {/* <CleanersDashboardHome {...this.state}/> */}
            <p>{DashboardCleanersHeaderConstant.visit}</p>
            <button className="button-header">{DashboardCleanersHeaderConstant.cleaning}</button>
            {this.state.roleID == "1" || this.state.roleName == "Super Admin" ?
              <div className="headerMenuAdminTop">
                <ul className="header-menuAdmin" >
                  <li>  <NavLink to="/DashboardScheduleUploadDownload" className="ConfigInActive" >{DashboardCleanersHeaderConstant.Config}</NavLink> </li>
                  <li>  <NavLink to="#" className="CleanersActive" >{DashboardCleanersHeaderConstant.CleanersDashboard}</NavLink> </li>
                </ul>
              </div>
              : null
            }
          </div>
          <div className="coop-visitor">
            <div className="coopIcon">
              <div className="roleName">{this.state.roleName}</div>
              <IconContext.Provider
                value={{ color: 'white', className: "global-class-name.Dashboard" }}
              >
                <IoIosContact size={30} />
              </IconContext.Provider>
              <ReusableButton buttonText={this.state.Name} className="RoleName"></ReusableButton>
              <p className="Logout"> <NavLink to="/CleanersDashboardHelpGuide" className="Help">{DashboardCleanersHeaderConstant.Help}</NavLink></p>
              <p onClick={this.handleLogout} className="Logout">{DashboardCleanersHeaderConstant.logout}</p>
              {/* <ReusableButton buttonText="Logout" onClick={this.handleLogout}></ReusableButton> */}
              {/* <ReusableButton buttonText={DashboardCleanersHeaderConstant.Cancel} onClick={this._toggleDivLogout} className="LogoutCancel"></ReusableButton> */}

            </div>
          </div>
        </div>
        <div className="dashboard-details">
          <div className="DashboardHeader">
            <div className="dashboard-store">
              <div className="dashboard-date-separate">
                <div className="AllStores">
                  <p className="dashboard-date-textStore">{DashboardCleanersHeaderConstant.SelectedStores}</p>
                  <select className="StoresSelect" onChange={this.handleStores}>
                    <option value="0" selected className="HeaderOption">{DashboardCleanersHeaderConstant.AllStores}</option>
                    {this.state.arrayStores.map((x, key) =>
                      <option id={key} className="HeaderOption" value={x.StoreId} key={key}>{x.StoreName}</option>
                    )}
                  </select>
                </div>
              </div>
              <div className="date-selector">
                <p className="dashboard-date-text">{DashboardCleanersHeaderConstant.DateRange}</p>
                <p className="dashboard-selected-date">{this.state.sessionStartUIDate} - {this.state.sessionEndUIDate}</p>
                <p className="dashboard-change-date" onClick={this._toggleDiv}>{DashboardCleanersHeaderConstant.ChangeDates}</p>

                <div className="dateRange">
                  <div className="slider" ref="toggle-div" style={{ display: 'none' }}>
                    <div><DateRange
                      onInit={this.handleSelect}
                      onChange={this.handleSelect}
                      calendars={2}
                      rangedCalendars={true}
                      linkedCalendars={true}
                      twoStepChange={true}
                      maxDate={this.state.currentDate}
                      // ranges={[selectionRange]}
                      startDate={this.state.startDateSelected}
                      endDate={this.state.endDateSelected}
                    />
                      <div className="CalendarButton">
                        <button className="date-slider-button" onClick={this.handleCancelDate}>{DashboardCleanersHeaderConstant.Cancel}</button>
                        <button className="date-apply-button" onClick={this.handleApplyDate}>{DashboardCleanersHeaderConstant.Apply}</button>
                      </div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }



}
export default DashboardCleanersHeader;